import React from "react";
import { KModal } from "../../ui-kit/k-modal/k-modal";
import { KModalFooter } from "../../ui-kit/k-modal/k-modal-footer";
import { type IKuikaButtonStatusLabels, type KuikaButtonStatus } from "../../ui-kit/kuika-button/kuika-button";
import KuikaModalIconWrapper from "../../ui-kit/kuika-modal-icon-wrapper/kuika-modal-icon-wrapper";
import KuikaH5 from "../../ui-kit/typography/H5/H5";
import KuikaText from "../../ui-kit/typography/Text/Text";
import "./branching-modal.scss";

export interface IDeactivateBranchingModalProps {
  showModal: boolean;
  inProgress?: boolean;
  /**
   * Where the commit stands (`KuikaButton` `status`). Given, the commit button carries it —
   * the busy word, then its ✓ or "Try again" — and `inProgress` no longer draws on it.
   */
  status?: KuikaButtonStatus;
  onClose: () => void;
  onDeactivate: () => void;
}

/** Its outcome is a toast — the branching UI goes with it — so it never shows a ✓. */
const DEACTIVATE_STATUS_LABELS: IKuikaButtonStatusLabels = { loading: "Deactivating" };

const DeactivateBranchingModal: React.FC<IDeactivateBranchingModalProps> = ({
  showModal,
  inProgress,
  status,
  onClose,
  onDeactivate
}) => {
  const footer = (
    <KModalFooter
      onCancel={onClose}
      submitLabel="Deactivate"
      submitTone="danger"
      onSubmit={onDeactivate}
      loading={inProgress}
      status={status}
      statusLabels={DEACTIVATE_STATUS_LABELS}
    />
  );

  return (
    <KModal
      showModal={showModal}
      closeModal={onClose}
      header="Deactivate Version Control"
      footer={footer}
      width={420}
      centered
    >
      <div className="kuika-branching-modal">
        <div className="kuika-branching-modal__header">
          <KuikaModalIconWrapper iconName="circle-x" intent="destructive" />
          <div className="kuika-branching-modal__title">
            <KuikaH5>Deactivate Version Control</KuikaH5>
          </div>
        </div>
        <div className="kuika-branching-modal__content">
          <div className="kuika-branching-modal__description">
            <KuikaText>This will revert the project to a non-branched state. The following will happen:</KuikaText>
          </div>
          <ul className="kuika-branching-modal__list">
            <li>
              Only the <strong>master branch</strong> entities will be kept
            </li>
            <li>
              Entities created on feature branches (never merged) will be <strong>removed</strong>
            </li>
            <li>
              All uncommitted changes on those branches will be <strong>discarded</strong>
            </li>
            <li>
              All branches and commit history will be <strong>permanently deleted</strong>
            </li>
          </ul>
          <div className="kuika-branching-modal__warning">
            <KuikaText>This action cannot be undone.</KuikaText>
          </div>
        </div>
      </div>
    </KModal>
  );
};

export default DeactivateBranchingModal;
